//
// QueryRequest.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./QueryRequestDataLevel";
import "./QueryRequestParameter";
import "./QueryRequestExpression";
import "../../dataDefinition/procedural/Argument";

var QueryRequest = createModule("BIRD::QueryRequest", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        rowTotals: 2,
        data: 7,
        argumentOverrides: [1],
        expressions: [1],
        columnTotals: 2,
        columnSubtotals: 2,
        sampleData: 2,
        forceDetail: 2,
        rowSubtotals: 2,
        indexStrings: 2,
        parameters: [1],
        dataLevel: 4,
        forceDetailResultDefinition: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default QueryRequest;
